import { Component } from 'preact';
import { framesStore } from '../store/frames';
import { Drawer } from 'flowbite';

export default class FrameListPage extends Component {

    private drawer!: Drawer;

    constructor(props: any) {
        super(props);
    }

    setCheckbox(e: InputEvent) {
        const target = e.currentTarget as HTMLInputElement;
        this.toggleFilter(target.name, target.value, target.checked);
    }

    toggleFilter(name: string, value: string, enabled: boolean) {
        const filter = {
            ...framesStore.filter.value
        };
        if (!filter[name]) {
            if (enabled) {
                filter[name] = new Set<string>();
            } else {
                return;
            }
        }
        
        filter[name] = new Set([...filter[name]]);
        if (enabled) {
            filter[name].add(value);
        } else {
            filter[name].delete(value);
        }


        framesStore.updateFilter(filter);
    }

    private loadFrames() {
        framesStore.load();
    }

    openFilter() {
        this.drawer.show();
    }

    closeFilter() {
        this.drawer.hide();
    }
  
    componentDidMount() {
        this.loadFrames();

        const filterDrawerElement = document.querySelector('#drawer-filter')
        this.drawer = new Drawer(document.querySelector('#drawer-filter') as HTMLElement, { onHide: () => filterDrawerElement?.classList.add('hidden'), onShow: () => filterDrawerElement?.classList.remove('hidden')});
    }

	render() {
        return <div id="frame-list-page">
            {location.pathname.indexOf('/brillen') < 0 ? <>
            <div class="bg-durchblick h-[300px] md:h-[450px]">
            
            </div>
        
            <div class="bg-[url('/images/breadcrumbs.png')] border-b-2 border-t-2 border-neutral-200">
                <div class="max-w-screen-xl mx-auto">
                    <div class="py-4 px-3 h-3/4 items-center text-center flex flex-col justify-center h-100 position-relative z-1">
                        <p class="font-handwritten mt-4 text-blue-800 text-2xl">
        
                            Wir bieten Ihnen im Herzen von Winnenden nachhaltige, regionale, modische sowie faire Brillen. 
                            <br />
                                Dabei sind nicht nur unsere Preise fair!
                                        
                        </p>
        
                        
                    </div>
                </div>
                
                
                <div class="mt-4">
                </div>
            </div>

            </>
             : ''}

            <div class="max-w-screen-xl mx-auto">
    

            <div class="px-3 z-2 relative my-8">
                
                <div class="flex flex-col items-center justify-center gap-x-4 gap-y-4">
                    <h1 class="text-3xl md:text-4xl font-bold text-neutral-600 text-shadow-lg shadow-white">Unsere Brillen:</h1>
                    <div class="flex flex-wrap justify-center gap-2">
                        {Object.entries(framesStore.filter.value).map(([key, list]) => {
                            return Array.from(list).map(entry => {
                            return <button onClick={() => this.toggleFilter(key, entry, false)}
                                    class="px-3 py-1 border border-gray-200 bg-neutral-100 rounded-2xl text-neutral-700
                                    hover:border-lime-400 group
                                    ">
                                {framesStore.attributesTitleMap.value[key]}: <span class="text-neutral-600 font-semibold">{entry}</span>
                                <span class="text-neutral-500 ml-2 group-hover:text-lime-400">&#x2715;</span>
                            </button>;
                            });
                        })}
                    </div>
                    <button onClick={() => this.openFilter()} class="text-durchblick-primary border-2 border-durchblick-primary hover:border-lime-400 focus:ring-4 focus:outline-none focus:ring-gray-300 rounded-lg text-xl px-5 py-2.5 text-center inline-flex items-center font-medium" type="button">
                    <svg class="w-4 h-4 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" d="M22 2H2v2.73l7.02 6.017L10.043 22h3.914l1.023-11.253L22 4.73zm-1 1v1H3V3zm-.852 2l-5.833 5h-4.63L3.852 5zm-7.105 16h-2.086l-.91-10h3.905z"/><path fill="none" d="M0 0h24v24H0z"/></svg>
                        Nach Ihrem Geschmack filtern
                    </button>

                    <p>Sie finden online nur eine Auswahl an Brillen, <span class="font-bold">viele weitere Brillen</span> finden Sie in unserem Geschäft.</p>


                </div>
                    <div class="mt-6 grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-3">
                        {framesStore.flatFrameAndCategoryList.value.map((item, index) => 
                            (
                                item.type === 'category' ? 

                                <div class="frame uppercase bg-durchblick-primary text-white card shadow w-100 p-4 text-2xl flex items-center justify-center font-extrabold font"
                                    dangerouslySetInnerHTML={{__html: framesStore.categoryTitleMap.value[item.key] + ':'}}
                                    >
                                    
                                </div>
                                    :
                                <div class={"frame card shadow w-100" + (framesStore.selectedFrame.value?.no === item.no ? ' selected' : '')}>
                                    <a href={'/brille/' + item.no + framesStore.filterQuery} aria-label={'Details zur Brillenfassung Nr. ' + item.no}><img src={item.thumbnail} alt={'Brillenfassung Nr. ' + item.no} class="card-img sm:h-[22.4vw] md:h-[13.35vw] lg:h-auto" /></a>
                                </div>
                                
                            )
                        )}
                    </div>

                </div>

                <div id="drawer-filter" class="hidden fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform -translate-x-full bg-white w-80 dark:bg-gray-800" tabindex={-1} aria-labelledby="drawer-label">
                    <h5 id="drawer-label" class="inline-flex items-center mb-4 text-base font-semibold text-gray-500 dark:text-gray-400">
                    <svg class="w-4 h-4 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" d="M22 2H2v2.73l7.02 6.017L10.043 22h3.914l1.023-11.253L22 4.73zm-1 1v1H3V3zm-.852 2l-5.833 5h-4.63L3.852 5zm-7.105 16h-2.086l-.91-10h3.905z"/><path fill="none" d="M0 0h24v24H0z"/></svg>
                    Finden Sie Ihre Brille</h5>
                    <button type="button" onClick={() => this.closeFilter()} class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white" >
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close menu</span>
                    </button>

                    <p class="mb-6 text-sm text-gray-500 dark:text-gray-400">
                        Wählen Sie aus
                    </p>

                    <div class="facets">
                    {framesStore.facetOrder.value
                    .filter(filterKey => framesStore.facets.value[filterKey].buckets.length > 0)
                    .map(filterKey => 
                        <div id={'facet-' + filterKey}>
                            <h3 class="mb-2 mt-6 font-semibold text-gray-900 dark:text-white">{framesStore.facets.value[filterKey].title}</h3>
                            <ul class="w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                {framesStore.facets.value[filterKey].buckets.map((option) => 
                                <li class="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input id={'vue-checkbox' + filterKey + option.id} onInput={(e) => this.setCheckbox(e)} type="checkbox" name={filterKey} checked={framesStore.filter.value[filterKey]?.has(option.key) } value={option.key} class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label for={'vue-checkbox' + filterKey + option.id} class="cursor-pointer w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{option.key} ({option.doc_count})</label>
                                    </div>
                                </li>
                                )}
                            </ul>
                        </div>
                    )}
                    </div>


                    <div class="flex justify-end gap-4 mt-4">
                        <button type="button" onClick={() => this.closeFilter()}  aria-controls="drawer-filter" class="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-white bg-durchblick-primary rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                            Brillen anzeigen <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                        </svg>
                        </button>
                    </div>
                </div>


               
            </div>
        </div>
	}
}